import { render } from "./AdminSupportTickets.vue?vue&type=template&id=4547d971&scoped=true"
import script from "./AdminSupportTickets.vue?vue&type=script&lang=js"
export * from "./AdminSupportTickets.vue?vue&type=script&lang=js"

import "./AdminSupportTickets.vue?vue&type=style&index=0&id=4547d971&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4547d971"]])

export default __exports__